import React from 'react';
import { Link } from 'react-router-dom';

const quickAccessItems = [
  {
    title: "Ny på skolen",
    desc: "Alt om værdier, optagelse, prøvedage og opskrivning for nye familier.",
    icon: "fa-regular fa-compass",
    link: "/ny-paa-skolen",
    badge: "For nye familier",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/odder-friskole-hero-happy-kids.jpg"
  },
  {
    title: "Hverdagen",
    desc: "Undervisning, klasser, Fritteren, musik, traditioner og billedgallerier.",
    icon: "fa-regular fa-sun",
    link: "/hverdagen",
    badge: "Skolelivet",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg"
  },
  {
    title: "Praktisk info",
    desc: "Mødetider, skolepenge, tilsynsrapporter, vedtægter og forældreinfo.",
    icon: "fa-regular fa-file-lines",
    link: "/praktisk-info",
    badge: "Dokumenter & Tider",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8.jpg"
  },
  {
    title: "Om skolen",
    desc: "Mød vores engagerede medarbejdere, bestyrelsen og støtteforeningen.",
    icon: "fa-regular fa-building",
    link: "/side/om-skolen",
    badge: "Folkene bag",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7245.jpg"
  }
];

export default function QuickAccess() {
  return (
    <section id="udforsk" className="py-16 lg:py-24 bg-white scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1D2923] tracking-tight">
              Find det du leder efter
            </h2>
          </div>
          <p className="text-sm sm:text-base text-[#5A6961] max-w-md">
            Uanset om du overvejer skolen til dit barn eller allerede er en del af hverdagen, finder du hurtigt vej her.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickAccessItems.map((item) => (
            <Link
              key={item.title}
              to={item.link}
              className="group relative bg-white rounded-3xl border border-[#d9e5d4] overflow-hidden shadow-xs hover:shadow-lg hover:border-[#88A68E] transition-all duration-300 flex flex-col"
            >
              {/* Image Preview */}
              <div className="relative h-44 w-full overflow-hidden bg-[#eef4e6]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-6 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-lg font-bold text-black font-serif-heading mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-black leading-relaxed font-normal">
                    {item.desc}
                  </p>
                </div>
                
                <div className="mt-4 pt-3 border-t border-[#d9e5d4] flex items-center text-xs font-bold text-black">
                  <span>Udforsk sektion</span>
                  <i className="fa-solid fa-chevron-right text-[10px] ml-1.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
